import React from "react";

import { Typography } from "components";

type FinancialBreakdownPanelProps = {
  /** Sits above the sections, e.g. the scenario pair picker the sections share. */
  header?: React.ReactNode;
  children: React.ReactNode;
  dataTestId?: string;
};

/** The tinted panel the Financial breakdown sections share: the cost and revenue summary, then every line. */
export const FinancialBreakdownPanel = ({ header, children, dataTestId = "financial-breakdown-panel" }: FinancialBreakdownPanelProps) => (
  <section className="financial-breakdown-panel" data-testid={dataTestId}>
    {header ? <div className="financial-breakdown-panel-header">{header}</div> : null}
    {children}
  </section>
);

type FinancialBreakdownSectionProps = {
  title: string;
  children: React.ReactNode;
  dataTestId?: string;
};

export const FinancialBreakdownSection = ({ title, children, dataTestId }: FinancialBreakdownSectionProps) => (
  <div className="financial-breakdown-section" data-testid={dataTestId}>
    <Typography variant="paragraph-l" className="financial-breakdown-section-title">
      {title}
    </Typography>
    {children}
  </div>
);

export default FinancialBreakdownPanel;
